module.exports = __webpack_public_path__ + "static/media/thanks.55505c38.svg";